module.exports = __webpack_public_path__ + "assets/img/72.46f473d2.png";